import { httpRequest } from '../../shared/lib/utils/httpClient';

export interface UserDetails {
  userId: number;
  username: string;
  firstName: string;
  lastName: string;
  email: string;
  role: string;
  phone: string;
  status: string;
}

export const getOpsUserDetails = async (
  email: string
): Promise<UserDetails> => {
  const response = await httpRequest<UserDetails>({
    url: `/operation/user/details?emailId=${email}`,
    method: 'GET',
  });
  return response;
};
